import { render } from "./SinistroAcordoDetalheView.vue?vue&type=template&id=59820fba&scoped=true"
import script from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAcordoDetalheView.vue?vue&type=style&index=0&id=59820fba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59820fba"]])

export default __exports__